import { render, staticRenderFns } from "./GalleryViewData.vue?vue&type=template&id=e4b5cebc"
import script from "./GalleryViewData.vue?vue&type=script&lang=js"
export * from "./GalleryViewData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports